import script from "./BlogDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetails.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetails.vue?vue&type=style&index=0&id=02447f97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02447f97"]])

export default __exports__